import sharedModule from '../../shared.module';

export default sharedModule.component('asCountry', {
    template: require('./asCountry.component.html'),
    style: require('./asCountry.component.css'),
    controller: controller,
    bindings: {
        id: '<',
        ngModel: '=?',
        ngChange: '&',
        onSelect: '&'
    }
});

function controller(countryService) {
    var vm = this;
    vm.placeholder = 'Select country';

    vm.$onInit = () => {
        vm.items = countryService.getCountries().then(data => {
            if (data && data.items && data.items.length > 0) {
                vm.items = data.items;
            }
        });
    };

    vm.onSelected = item => {
        vm.onSelect({ item: item });
        vm.ngChange({ item: item });
    };
}



// WEBPACK FOOTER //
// ./modules/shared/components/asCountry/asCountry.component.js